<template>
  <div>
    <v-text-field
      v-money="currencyConfig"
      ref="amount"
      v-model="price"
      :label="label"
      prefix="$"
    />
  </div>
</template>

<script>
import { VMoney } from 'v-money'
export default {
  directives: {
    money: VMoney
  },
  props: {
    value: {
      type: String,
      default: '0.00'
    },
    max: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currencyConfig: {
        thousands: ''
      }
    }
  },
  computed: {
    price: {
      get () {
        return this.validateAmount(this.value, this.max)
      },
      set (value) {
        value = this.validateAmount(value, this.max)
        this.$refs.amount.$el.getElementsByTagName('input')[0].value = value
        this.$emit('input', value)
      }
    }
  },
  methods: {
    update () {
      this.$emit('input', this.validatedAmount)
    },
    validateAmount (amount, max) {
      return max && Number(amount) > Number(max) ? max : amount
    }
  }
}
</script>
